import { inject, Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';

import { createEffectFactory } from '@core/ngrx-legacy';

import { TellentGettingStartedHttpClient } from './tellent-getting-started.http-client';
import { TellentGettingStartedContentActions } from './tellent-getting-started.store';

@Injectable({
  providedIn: 'root',
})
export class TellentGettingStartedContentEffects {
  #actions$ = inject(Actions);
  #http = inject(TellentGettingStartedHttpClient);

  public effects = createEffectFactory(TellentGettingStartedContentActions, this.#actions$);

  public fetch$ = this.effects(TellentGettingStartedContentActions.fetch, () =>
    this.#http.fetchContent(),
  );
}
